import { Persona } from './types';

export const PERSONAS: Persona[] = [
  {
    name: 'The Focused Scholar',
    description:
      'High attention, positive mood, and optimal environment with spaced repetition and good sleep.',
    params: {
      attention: 10,
      mood: 8,
      environment: 9,
      repetition: 5,
      spacing: 8,
      sleep: 9,
    },
  },
  {
    name: 'The Distracted Student',
    description:
      'Low attention and poor environment, trying to compensate with high repetition but no spacing.',
    params: {
      attention: 3,
      mood: 5,
      environment: 2,
      repetition: 10,
      spacing: 1,
      sleep: 4,
    },
  },
  {
    name: 'The Sleep-Deprived',
    description:
      'Strong encoding and repetition, but zero biological consolidation due to lack of sleep.',
    params: {
      attention: 9,
      mood: 7,
      environment: 8,
      repetition: 5,
      spacing: 5,
      sleep: 0,
    },
  },
];
